module.exports = __webpack_public_path__ + "img/face-bad.8c72707a.svg";